import Worker from '@wmfe/mach-pro-worker';
import { reportRaptorMetrics } from '@/src/common/SLRaptor';
import { radomUUID } from '@/src/utils/uuid';
import { ResourceSDK } from '@sailor/mkt-resource-position-sdk';
import {
  getToken, isSameToken, callModule
} from './util';
import { logEventNode } from './report';
import { TraffichavenStatus, getTraffichavenStatus } from '../traffichaven/util';

const Login = Mach.requireModule('Login');
// const SLPop = Mach.requireModule('SLPop')
// const Horn = Mach.requireModule('SLCHorn');
const SLCompass = Mach.requireModule('SLCompass');
const SLAlita = Mach.requireModule('SLAlita');
// const SLCommon = Mach.requireModule('SLCommon')

// 判断是否在首页，如果非首页不弹窗
let isInHomePage = true;
const inServiceArea = false;
let waitingData = null;
let dspData = null;
let hasAddress = false;
let isLoading = false;

// 控制非登录场景的频次
let hasShowLoginPop = false;

// 控制其他场景的频次
let hasShowOtherPop = false;

// 控制dsp弹窗
let hasShowDspPop = false;

// 获取经纬度
const getLatLng = () => {
  const SLLocation = Mach.requireModule('SLLocation');
  const location = SLLocation?.getLocation() || {};
  return {
    latitude: location?.latitude,
    longitude: location?.longitude,
    actualLatitude: location?.actualLatitude,
    actualLongitude: location?.actualLongitude,
  };
};

const checkDspPopOpen = () => {
  console.log(isLoading, hasAddress, hasShowDspPop, '+++++dspopen');
  logEventNode('FFS_START_CHECK', { data: { isLoading, hasAddress, hasShowDspPop }, withRaptor: true });
  if (isLoading) return false;
  if (!hasAddress) return false;
  if (hasShowDspPop) {
    return false;
  }
  // SA地区游客逻辑，需要防止在注册信息补充完成前发券
  const compassInfo = SLCompass?.getCompassInfo?.();
  if ((compassInfo?.region !== 'HK') && !isInHomePage) {
    return false;
  }
  logEventNode('FFS_PASS_CHECK', { data: {}, withRaptor: true });
  return true;
};

const openDspPop = async () => {
  if (dspData) {
    // console.log(dspData,'dspData 设置 弹窗为true');
    hasShowDspPop = true;
  }
  const encodeData = JSON.parse(JSON.stringify(dspData));
  dspData = null;
  const params = {
    type: 'PULL',
    mainSchemaUrl: 'sailorc://keeta.com/machproalert',
    lxConfig: {
      cid: 'c_waimai_c_overseas_aatucy3n',
      lxParams: {
      },
    },
    inputParams: {},
    data: encodeData,
  };
  logEventNode('FFS_LOAD_ALERT', { data: { encodeData }, withRaptor: true });
  // 调用sdk
  ResourceSDK.default(params);
};
//投放系统首页弹窗
const getDspdata = (curToken: number) => {
  isLoading = true;
  const networkModule = Mach.requireModule('Network');
  const loc = getLatLng();
  networkModule.requestWx(
    {
      url: 'v1/channel/launch/task/list',
      method: 'POST',
      dataType: 'json',
      data: {
        commonChannelId: 'home-pop-10002',
        bundleVersion: '0.0.22',
        longitude: loc?.actualLongitude,
        latitude: loc?.actualLatitude,
        homePageLatitude: loc?.latitude,
        homePageLongitude: loc?.longitude,
        fingerPrint: true,
      },
      headers: {
      },
    },
    (response) => {
      isLoading = false;
      const isSame = isSameToken(curToken);
      // console.log("[dspisSame]:", isSame);
      logEventNode('FFS_RECEIVE_DATA', { data: { isSame, isInHomePage, response } });
      // if (isSame) {
      //   return;
      // }
      const error = response?.error;
      const { code, msg, data } = response.data || {};
      if (code !== 0 || data) {
        // 有数据命中 或 接口错误
        reportRaptorMetrics({ FFS_RECEIVE_DATA: 1 }, { code: String(code) });
      }
      if (error || code !== 0) {
        Mach.requireModule('Raptor').reportBusinessException('投放天降弹窗接口异常', JSON.stringify(response), { type: 'normal' });
        // eslint-disable-next-line prefer-promise-reject-errors
        Worker.emit('fall_from_sky_popup_to_worker', {
          msg,
        });
        return;
      }
      dspData = data ? { ...data } : null;
      if (isInHomePage && dspData) {
        openDspPop();
      }
    }
  );
};

// 老首页弹窗系统
const checkShouldOpenPopup = (eventId: string) => {
  const WMABTest = Mach?.requireModule?.('SLABStrategy');
  const strategy = WMABTest?.getStrategy?.({
    sceneKey: 'launch_old_sky_popup',
    groupKey: 'launch_old_sky_popup_exp1',
  });
  if (strategy?.expKey?.includes?.('A')) {
    return false;
  }
  const isLogin = Login?.isLogin?.();
  logEventNode('FFS_START_CHECK', {
    eventId,
    data: {
      isLoading, hasAddress, hasShowOtherPop, hasShowLoginPop, isLogin
    }
  });
  if (isLoading) return false;
  if (!hasAddress) return false;
  if (hasShowOtherPop && hasShowLoginPop) {
    return false;
  }
  if (isLogin && hasShowOtherPop) {
    return false;
  }
  if (!isLogin && hasShowLoginPop) {
    return false;
  }
  logEventNode('FFS_PASS_CHECK', { eventId, data: {}, withRaptor: true });
  return true;
};

// 天降弹窗接口请求
const navigateToPop = () => {
  const dspType = waitingData?.dspType;
  const encodeData = encodeURIComponent(JSON.stringify(waitingData));
  switch (dspType) {
    case 1:
    case 2: {
      hasShowOtherPop = true;
      break;
    }
    case 3: {
      hasShowLoginPop = true;
      break;
    }
  }
  waitingData = null;
  callModule(
    'Router',
    'navigateTo',
    (result) => {
      if (!result.success) {
        // @ts-ignore
        // const WMToast = Mach.requireModule('Toast');
        // WMToast.show('跳转失败', 2);
        console.log(
          'navigate error: mach_pro_sailor_c_fall_from_sky_popup ~~~~'
        );
      }
    },
    `sailorc://keeta.com/machproalert?bundle_name=mach_pro_sailor_c_fall_from_sky_popup&data=${encodeData}`,
    {}
  );
};

export const openFallFromSkyPopup = (curToken: number, eventId: string) => {
  isLoading = true;
  const location = getLatLng();
  const networkModule = Mach.requireModule('Network');
  networkModule.requestWx(
    {
      url: 'dsp/homepage/pop/get',
      method: 'POST',
      dataType: 'json',
      data: {
        ...location,
        bundleVersion: '0.0.22'
      },
      headers: {
        // userid: 123,
        // swimlane: 'lishaoxing-nhloq',
      },
    },
    (response) => {
      isLoading = false;
      const isSame = isSameToken(curToken);
      console.log('[isSame]:', isSame);
      logEventNode('FFS_RECEIVE_DATA', { eventId, data: { isSame, isInHomePage, response } });
      if (!isSame) {
        return;
      }
      const error = response?.error;
      const { code, msg, homePagePopUpDTO } = response?.data || {};
      if (error || code !== 0 || !homePagePopUpDTO || homePagePopUpDTO?.dspType === 0) {
        if (error || code !== 0) {
          Mach.requireModule('Raptor').reportBusinessException('天降弹窗接口异常', JSON.stringify(response), { type: 'normal' });
        }
        // eslint-disable-next-line prefer-promise-reject-errors
        Worker.emit('fall_from_sky_popup_to_worker', {
          msg,
        });
        return;
      }
      waitingData = { eventId, ...(homePagePopUpDTO || {}) };
      if (isInHomePage && (TraffichavenStatus.FINISH === getTraffichavenStatus())) {
        navigateToPop();
      }
    }
  );
};

// 有地址, 有核心参数
Mach.on('homepage_popup_to_worker', (data) => {
  const eventId = radomUUID();
  logEventNode('FFS_EVENT_HOMEPAGE_POPUP', { eventId, data, withRaptor: true });
  hasAddress = true;
  console.log('[event homepage_popup_to_worker]:', data);
  // Toast.show('===szq===Mach on native_to_worker')
  // 调用天降弹窗
  const shouldOpen = checkShouldOpenPopup(eventId);
  if (checkDspPopOpen()) {
    getDspdata(getToken());
  }
  if (shouldOpen) {
    openFallFromSkyPopup(getToken(), eventId);
  }
});

Worker.on('address_popup_show_to_worker', () => {
  console.log('[event address_popup_show_to_worker]: ~~~');
  const eventId = radomUUID();
  logEventNode('FFS_EVENT_ADDRESS_SHOW', { eventId, data: {} });
  hasAddress = false;
});

Worker.on('address_popup_close_to_worker', ({ inServiceArea }) => {
  console.log('[event address_popup_close_to_worker]:', inServiceArea);
  const eventId = radomUUID();
  logEventNode('FFS_EVENT_ADDRESS_CLOSE', { data: { inServiceArea }, withRaptor: true, eventId });
  if (inServiceArea) {
    hasAddress = true;
    const shouldOpen = checkShouldOpenPopup(eventId);
    if (checkDspPopOpen()) {
      getDspdata(getToken());
    }
    if (shouldOpen) {
      openFallFromSkyPopup(getToken(), eventId);
    }
  }
});

Mach.on('homepage_appear_to_worker', ({ appear }) => {
  console.log('[event homepage_appear_to_worker]:', appear);
  isInHomePage = !!appear;

  if (isInHomePage) {
    const eventId = radomUUID();
    logEventNode('FFS_EVENT_HOMEPAGE_APPEAR', { data: { waitingData: waitingData || null }, withRaptor: true, eventId });
    if (waitingData && (TraffichavenStatus.FINISH === getTraffichavenStatus())) {
      navigateToPop();
      return;
    }
    if (dspData && (TraffichavenStatus.FINISH === getTraffichavenStatus())) {
      openDspPop();
      return;
    }
    const shouldOpen = checkShouldOpenPopup(eventId);
    if (checkDspPopOpen()) {
      getDspdata(getToken());
    }
    if (shouldOpen) {
      openFallFromSkyPopup(getToken(), eventId);
    }
  }
});

// 拉承一体 已结束, 天降可以弹出来了
export function notiSkyTraffichavenFinish() {
  const gTraffichavenStatus = getTraffichavenStatus();
  console.log('[event noti_sky_traffichaven_finish]: ', gTraffichavenStatus);

  if (isInHomePage && dspData && (TraffichavenStatus.FINISH === gTraffichavenStatus)) {
    openDspPop();
    return;
  }
  if (isInHomePage && waitingData && (TraffichavenStatus.FINISH === gTraffichavenStatus)) {
    navigateToPop();
    return;
  }

  if (isInHomePage) {
    const eventId = radomUUID();
    logEventNode('FFS_EVENT_TRAFFICHAVEN_FINISH', { data: { waitingData: waitingData || null }, withRaptor: true, eventId });

    if (checkDspPopOpen()) {
      getDspdata(getToken());
    }
    const shouldOpen = checkShouldOpenPopup(eventId);
    if (shouldOpen) {
      openFallFromSkyPopup(getToken(), eventId);
    }
  }
}

/**
 * 发券（新人大礼包）
 * @param couponBizCode 发券渠道 1：门店页的新人横条； 2：主站门店提单 3：一口价专区提单 4：首页shared_worker兜底发放
 */
export const sharedWorkerCouponSendRequest = (couponBizCode: number) => {
  // 定位信息
  const SLLocation = Mach.requireModule('SLLocation');
  const Network = Mach.requireModule('Network');
  const locationObj = SLLocation?.getLocation() || {};
  const location = {
    latitude: locationObj?.latitude,
    longitude: locationObj?.longitude,
    actualLatitude: locationObj?.actualLatitude,
    actualLongitude: locationObj?.actualLongitude
  };

  const param = {
    bizCode: couponBizCode,
    ...location,
  };

  const params = {
    url: 'dsp/newuser/coupon/send',
    method: 'POST',
    dataType: 'json',
    data: param,
  };
  Network.requestWx(params, (result: any) => {
    if (result?.data?.code !== 0) {
      // 请求失败，异常上报
      Mach.requireModule('Raptor').reportBusinessException(params.url, JSON.stringify({ bizCode: couponBizCode, result }), { type: 'normal' });
    }
  });
};

// 监听登录成功，调用新人大礼包券的发放
const eventOfLogin = Login?.eventOfLogin();
Mach.requireModule('EventCenter').addListener(eventOfLogin, () => {
  try {
    sharedWorkerCouponSendRequest(4);
  } catch (error) {
    console.log(error);
  }
});
// 常规请求，只有url是必传
const commonRequest = ({
  method, dataType, url, data, headers
}: { method?: string; dataType?: string; url: string; data?: any; headers?: any; }) => {
  const Network = Mach.requireModule('Network');
  const { fingerPrint, fingerprint, ...newData } = data || {};
  const params = {
    dataType: dataType || 'json',
    url,
    method: method || 'GET',
    params: (method || 'GET') === 'GET' ? newData || null : null,
    data: (method || 'GET') === 'POST' ? newData || {} : null,
    headers: headers || {},
  };
  return new Promise<any>((resolve, reject) => {
    // 设备指纹通过requestWx方法请求，fingerprint参数在端内自动写入
    Network[fingerPrint || fingerprint ? 'requestWx' : 'request'](params, (result: any) => {
      if (result.error) {
        reject(result.error);
      } else {
        if (result.data && result.data.code === 0) {
          resolve(result.data);
        } else {
          reject(result.data);
        }
      }
    });
  });
};
// Alita规则命中
if (SLAlita) {
  SLAlita?.observeSceneKey?.('sailor_alita_key', async (result) => {
    const {
      intention_id, name, scene_id, scene_key
    } = result.newIntention || {};
    // intention_id规则ID，name规则Key，scene_key场景key，scene_id场景ID
    const { userId } = Login?.getUserInfo || {};
    // 命中交互规则
    reportRaptorMetrics({ SailorAlitaRule: 1 }, {
      userId, intention_id, intention_key: name, scene_id, scene_key
    });
    try {
      const requestData = await commonRequest({
        url: 'accurate/v1/campagin/alita/report',
        data: {
          alitaSceneId: scene_id,
          alitaRuleId: intention_id
        },
        method: 'POST',
      });
      // 接口成功
      reportRaptorMetrics({ SailorAlitaRuleStatus: 1 }, {
        status: '1', intention_id, intention_name: name, scene_id, scene_key, requestData: JSON.stringify(requestData)
      });
    } catch (error) {
      // 接口失败
      reportRaptorMetrics({ SailorAlitaRuleStatus: 0 }, {
        status: '0', intention_id, intention_name: name, scene_id, scene_key, error: JSON.stringify(error)
      });
    }
  });
}

// // 获取人群实验命中数据
// const getPersonaExp = async ({personaId, expSceneKey}: {personaId: number, expSceneKey: string}) => {
//   reportRaptorMetrics({'SailorAlitaPersonaExp': 1}, { personaId: String(personaId), expSceneKey });
//   try {
//     const requestData = await commonRequest({
//       url: 'accurate/persona_and_ab_judge',
//       data: {
//         personaId,
//         expSceneKey
//       },
//       method: 'POST',
//     })
//     return requestData?.data
//   } catch (error) {
//     // Raptor上报人群实验出错
//     reportRaptorMetrics({'SailorAlitaHintResult': 0}, {
//       type: '105',
//       reason: '调用人群实验接口报错',
//       bundle_name: 'mach_pro_sailor_mkt_alita_push',
//       show_page: 'mach_pro_sailor_c_home_page_main'
//     });
//     return undefined
//   }
// }
// // 获取我的券列表接口
// const getMyCoupon = async () => {
//   try {
//     const requestData = await commonRequest({
//       url: 'v1/userinfo/my/coupon',
//       data: {
//         pageSize: 20,
//         couponStatus: 0,
//         page: 0
//       },
//       method: 'POST',
//     })
//     return requestData?.data
//   } catch (error) {
//     // Raptor上报获取我的券列表出错
//     reportRaptorMetrics({'SailorAlitaHintResult': 0}, {
//       type: '104',
//       reason: '获取我的券列表接口报错',
//       bundle_name: 'mach_pro_sailor_mkt_alita_push',
//       show_page: 'mach_pro_sailor_c_home_page_main'
//     });
//     return undefined
//   }
// }
// // Alita规则命中
// SLAlita?.observeSceneKey?.("sailor_alita_intent_key_test", async (result) => {
//   const { env } = SLCommon ? SLCommon.getEnv() : { env: 'Test' }
//   const isText = (env === 'Test')
//   const { name } = result.newIntention || {}
//   // const { intention_id, name, scene_id, scene_key } = result.newIntention || {}
//   // reportRaptorMetrics({'SailorAlitaHint': 1}, { observeType: 'observeSceneKey', intention_id, name, scene_id, scene_key });
//   if (name && name === 'test_step2') { // 测试用户在门店页停留超过10s，并在首页页停留超过10S
//     // alita规则命中
//     const personaExpList = isText
//       ? [{personaId: 1010757, expSceneKey: 'test_Alita_key', personaName: '测试人群'}]
//       : [
//         {personaId: 1118202, expSceneKey: 'test_Alita_key', personaName: '潜客'}, // 潜客
//         {personaId: 1118208, expSceneKey: 'test_Alita_key', personaName: '新客'}, // 新客
//         {personaId: 1118214, expSceneKey: 'test_Alita_key', personaName: '老客'} // 老客
//       ]
//     // 命中特定alita规则请求人群实验是否命中
//     const personaExpInfo = await Promise.all(personaExpList.map(item => getPersonaExp(item)))
//     personaExpInfo.forEach(async (item, index) => {
//       if (item) {
//         const { personaIdJudgePass, expList } = item || {}
//         if (personaIdJudgePass) {
//           // 人群X命中
//           const { groupKey, expKey } = expList[0] || {}// 人群命中
//           reportRaptorMetrics({'SailorAlitaPersona': 1}, { personaId: isText ? '1010757' : String(personaExpList[index].personaId), groupKey, expKey });
//           if (groupKey === 'test_Alita_key_exp1') {
//             // 命中实验
//             if (expKey === 'alita_show') {
//               // 命中实验组
//               reportRaptorMetrics({'SailorAlitaExp': 1}, { personaId: isText ? '1010757' : String(personaExpList[index].personaId), groupKey, expKey });
//               const couponData = await getMyCoupon()
//               if (couponData) {
//                 const free_coupon = 40001 // 免配券
//                 const { defaultUseCouponLink, couponList = [] } = couponData || {}
//                 if (couponList && couponList.length) {
//                   // 有券
//                   // 含有非免配券
//                   const hasNoFreeCoupon = couponList.some(item => {
//                     const { couponBaseInfoDto } = item
//                     return couponBaseInfoDto?.subCategory !== free_coupon
//                   })
//                   const noFreeCouponList = couponList.filter(item => {
//                     const { couponBaseInfoDto } = item
//                     return couponBaseInfoDto?.subCategory !== free_coupon
//                   })
//                   let couponInfo = {}
//                   if (hasNoFreeCoupon) {
//                     // 获取面值最大的券
//                     couponInfo = noFreeCouponList.reduce((max, item) => {
//                       return parseFloat(item.couponDisplayInfoDto.couponAmountString) > parseFloat(max.couponDisplayInfoDto.couponAmountString) ? item : max;
//                     }, noFreeCouponList[0]);
//                   } else {
//                     // 获取一张免配券
//                     couponInfo = couponList[0]
//                   }
//                   reportRaptorMetrics({'SailorAlitaCoupon': 1}, {
//                     personaId: isText ? '1010757' : String(personaExpList[index].personaId),
//                     groupKey,
//                     expKey,
//                     coupon: JSON.stringify(couponInfo)
//                   });
//                   // 整理传递给machPro的数据
//                   SLPop?.show({
//                     bundle_name: 'mach_pro_sailor_mkt_alita_push',
//                     data: {
//                       couponViewId: couponInfo?.couponBaseInfoDto?.couponViewId, // 优惠券ID
//                       name: couponInfo?.couponDisplayInfoDto?.name, // 优惠券名称
//                       subCategory: couponInfo?.couponBaseInfoDto?.subCategory, // 优惠券类型
//                       couponAmountText: couponInfo?.couponDisplayInfoDto?.couponAmountText, // 免配文案
//                       currencyType: couponInfo?.couponDisplayInfoDto?.currencyType, // 金额符号
//                       couponAmountString: couponInfo?.couponDisplayInfoDto?.couponAmountString, // 金额值
//                       startTime: couponInfo?.couponBaseInfoDto?.startTime, // 开始时间
//                       buttonText: couponInfo?.couponDisplayInfoDto?.buttonText, // 按钮名称
//                       buttonUrl: couponInfo?.couponDisplayInfoDto?.buttonUrl, // 按钮跳转地址
//                       sillAmountText: couponInfo?.couponDisplayInfoDto?.sillAmountText, // 按钮跳转地址
//                       defaultUseCouponLink, // 默认跳转地址
//                       personaId: personaExpList[index].personaId // 人群Id
//                     },
//                     page: 'mach_pro_sailor_c_home_page_main'
//                   })
//                 } else {
//                   // Raptor上报没有券
//                   reportRaptorMetrics({'SailorAlitaHintResult': 0}, {
//                     type: '103',
//                     reason: '用户没有券，不会触发push',
//                     bundle_name: 'mach_pro_sailor_mkt_alita_push',
//                     show_page: 'mach_pro_sailor_c_home_page_main'
//                   });
//                 }
//               }
//             } else {
//               // 对照组
//               const { userId, userName } = Login?.getUserInfo || {}
//               // Raptor上报时间戳
//               reportRaptorMetrics({'SailorAlitaHintResult': 0}, {
//                 type: '102',
//                 reason: '为实验对照组，不会触发push',
//                 bundle_name: 'mach_pro_sailor_mkt_alita_push',
//                 show_page: 'mach_pro_sailor_c_home_page_main'
//               });
//               reportRaptorMetrics({'SailorAlitaExpNoShow': 1}, {
//                 personaId: String(personaExpList[index].personaId),
//                 personaName: personaExpList[index].personaName,
//                 expKey,
//                 userId,
//                 userName,
//                 time: String(Date.now()) // 毫秒数
//               });
//               const couponData = await getMyCoupon()
//               if (couponData) {
//                 reportRaptorMetrics({'SailorAlitaExpNoShowHasCoupon': 1}, {
//                   personaId: String(personaExpList[index].personaId),
//                   personaName: personaExpList[index].personaName,
//                   expKey,
//                   userId,
//                   userName,
//                   time: String(Date.now()) // 毫秒数
//                 });
//               }
//             }
//           }
//         } else {
//           // Raptor上报人群没命中
//           reportRaptorMetrics({'SailorAlitaHintResult': 0}, {
//             type: '101',
//             reason: '人群未命中',
//             bundle_name: 'mach_pro_sailor_mkt_alita_push',
//             show_page: 'mach_pro_sailor_c_home_page_main'
//           });
//         }
//       }
//     })
//   } else {
//     //Raptor上报alita获取成功但是没有ruleId
//     reportRaptorMetrics({'SailorAlitaHintResult': 0}, {
//       type: '100',
//       reason: `alita获取成功,但是当前(${name})没有匹配到对应的意图名称(test_step2)`,
//       bundle_name: 'mach_pro_sailor_mkt_alita_push',
//       show_page: 'mach_pro_sailor_c_home_page_main'
//     });
//   }
// });
